module.exports = __webpack_public_path__ + "img/preloader-track.04f8ebc8.svg";